export default {"src":"/catalog/_next/static/media/Menu.bfc0ffb6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};